import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { Textarea } from '../ui/textarea';

interface ChatInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const ChatInput = React.forwardRef<HTMLTextAreaElement, ChatInputProps>(({ className, ...props }, ref) => (
  <Textarea
    autoComplete='off'
    ref={ref}
    name='message'
    className={twMerge(
      'max-h-[100px] text-sm disabled:cursor-not-allowed disabled:opacity-50 w-full  resize-none min-h-5 border-none p-0 pe-1 focus-visible:ring-0 focus-visible:ring-offset-0 field-sizing-content rounded-none',
      className
    )}
    {...props}
  />
));
ChatInput.displayName = 'ChatInput';

export { ChatInput };
